export default __webpack_public_path__ + "static/media/reflexMb.2453aef5.png";